import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { Divider } from 'semantic-ui-react';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { RouterProps } from 'react-router';
import { PaymentJournalData, PaymentJournalSearchResponse, TreaterDto, TreaterSummaryData } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import moment from 'moment';
import styled from 'styled-components';
import { noop } from 'utils/functionUtils';
import { getAllTreaters } from 'services/treaterServices';
import PaymentJournalOptionsSegment from 'components/billing/payment-journal/segments/PaymentJournalOptionsSegment';
import PaymentJournalTableSegment from 'components/billing/payment-journal/segments/PaymentJournalTableSegment';
import { PaymentJournalPaymentType } from 'ts-types/api.enums';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export interface PaymentJournalFormData {
  bills: Array<PaymentJournalSearchResponse>,
  mandateId: number,
  fromDate: string,
  toDate: string,
  paymentType: PaymentJournalPaymentType,
  cashBox?: number,
  treaterId?: number
}

interface Props extends AuthConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  bills: Array<PaymentJournalSearchResponse>,
  treaterSummaryData: Array<TreaterSummaryData>,
  totalAmount: number,
  totalPaidAmount: number,
  billsLoading: boolean,
  formData: PaymentJournalFormData,
  treaters: Array<DropdownOption>,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class PaymentJournalView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {getMessage} = props;

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      bills: [],
      treaterSummaryData: [],
      totalAmount: 0,
      totalPaidAmount: 0,
      billsLoading: false,
      formData: this.initialOutputFormValues(),
      treaters: [],
      cancelTokenSource: cancelTokenSource
    };

    getAllTreaters(cancelTokenSource).then(response => {

          const mappedTreaters: Array<DropdownOption> = response.map((treater: TreaterDto) => ({
            key: treater.id,
            text: treater.username,
            value: treater.id
          }));

          this.setState({
            treaters: mappedTreaters
          })
        })
        .catch(() => {
          this.setErrorMessage(getMessage("error.general"));
        })
        .finally(noop);
  }

  initialOutputFormValues = (): PaymentJournalFormData => {

    const {currentUser} = this.props;

    const fromDate = moment().startOf('month').format("YYYY-MM-DD");
    const toDate = moment().endOf('month').format("YYYY-MM-DD");

    return {
      mandateId: currentUser ? currentUser.userConfig.mandateId : 1,
      fromDate: fromDate,
      toDate: toDate,
      paymentType: PaymentJournalPaymentType.ALL,
      cashBox: 0,
      bills: []
    }
  };

  setOutputFormData = (outputFormData: PaymentJournalFormData): void => {
    this.setState({
      formData: outputFormData
    });
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  onFilterBills = (paymentJournalData: PaymentJournalData) => {
    this.setState({
      bills: paymentJournalData.bills,
      treaterSummaryData: paymentJournalData.treaterSummaryData,
      totalAmount: paymentJournalData.totalAmount,
      totalPaidAmount: paymentJournalData.totalPaidAmount
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  render(): React.ReactElement {

    const {
      bills,
      treaterSummaryData,
      totalAmount,
      totalPaidAmount,
      billsLoading,
      formData,
      treaters,
      errorMessage
    } = this.state;

    return (
        <PraxStyledSegment>
          <StyledContainer>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            <PaymentJournalOptionsSegment
                bills={bills}
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
                setOutputFormData={this.setOutputFormData}
                treaters={treaters}
                setErrorMessage={this.setErrorMessage}
            />
            <Divider/>
            <PaymentJournalTableSegment
                bills={bills}
                treaterSummaryData={treaterSummaryData}
                totalAmount={totalAmount}
                totalPaidAmount={totalPaidAmount}
                billsLoading={billsLoading}
                formData={formData}
                treaters={treaters}
                setErrorMessage={this.setErrorMessage}
            />
          </StyledContainer>
        </PraxStyledSegment>
    );
  }

}

export default withAuthContext(withMessages(PaymentJournalView));
